<template>
  <v-layout>
    <v-flex v-if="showCost">
      <v-layout
        v-for="(subtotal, i) in moveInCost.fees"
        :key="`fee${i}`"
        :class="parent === 'rentalInfo' ? 'pb-2' : 'px-4 pb-1'"
      >
        <v-layout>
          <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">{{ subtotal.name }}</v-flex>
          <v-flex xs2 class="text-right">${{ parseFloat(subtotal.cost).toFixed(2) }}</v-flex>
        </v-layout>
      </v-layout>
      <div v-if="merchandiseCart.length">
        <v-layout
          :class="parent === 'rentalInfo' ? 'pb-2' : 'px-4 pb-1'"
          v-for="(item, i) in merchandiseCart"
          :key="i"
        >
          <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">{{ item.name }} x {{ item.quantity }}</v-flex>
          <v-flex xs2 class="text-right">${{ (parseFloat(item.price) * item.quantity).toFixed(2) }}</v-flex>
        </v-layout>
      </div>
      <!-- @todo We'll eventually break this down by fee -->
      <v-layout :class="parent === 'rentalInfo' ? 'pb-2' : 'px-4 pb-1'" v-if="showFeesTax">
        <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">Fees Tax</v-flex>
        <v-flex xs2 class="text-right">${{ parseFloat(moveInCost.fee_tax_total).toFixed(2) }}</v-flex>
      </v-layout>
      <v-layout :class="parent === 'rentalInfo' ? 'pb-2' : 'px-4 pb-1'">
        <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">Rent Tax</v-flex>
        <v-flex xs2 class="text-right">${{ parseFloat(moveInCost.rent_tax).toFixed(2) }}</v-flex>
      </v-layout>
      <v-layout :class="parent === 'rentalInfo' ? 'pb-2' : 'px-4 pb-1'" v-if="merchTaxTotal">
        <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">Sales Tax</v-flex>
        <v-flex xs2 class="text-right">${{ (merchTaxTotal).toFixed(2) }}</v-flex>
      </v-layout>
      <v-layout :class="parent === 'rentalInfo' ? '' : 'px-4 pb-1'" v-if="showTppTax">
        <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">TPP Tax</v-flex>
        <v-flex xs2 class="text-right">${{ parseFloat(moveInCost.tpp_tax).toFixed(2) }}</v-flex>
      </v-layout>
      <v-flex :class="parent === 'rentalInfo' ? 'xs6' : 'xs12'">
        <v-divider :class="parent === 'rentalInfo' ? 'my-3' : 'mx-4 my-2'" />
      </v-flex>
      <v-layout :class="parent === 'rentalInfo' ? 'pb-1' : 'px-4'" class="subheading font-weight-bold pb-3">
        <v-flex :class="parent === 'rentalInfo' ? 'xs4' : 'xs10'">Non-refundable Total Charges:</v-flex>
        <v-flex xs2 class="text-right">${{ moveInCost.total }}</v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="invalidPromotion && options.selectedPromotion === null" class="pa-4 xs12" wrap>
      <v-icon color="red" dense>warning</v-icon>
      The promotion associated to this reservation is no longer active.
      Please select a new promotion to calculate total.
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    parent: {
      type: String
    }
  },

  computed: {
    ...mapState({
      merchandiseCart: state => state.facilities.merchandiseCart,
      moveInCost: state => state.facilities.moveInCost,
      options: state => state.tenant.options,
      invalidPromotion: state => state.reservations.invalidPromotion,
      promotionOptions: state => state.facilities.promotionOptions
    }),
    ...mapGetters({
      merchCartSubtotal: "merchCartSubtotal",
      merchTaxTotal: "merchTaxTotal"
    }),
    showCost() {
      if (!this.moveInCost || !this.options) {
        return false;
      }

      return true;
    },
    showTppTax() {
      if (
        this.moveInCost.tpp_tax &&
        parseFloat(this.moveInCost.tpp_tax) > 0
      ) {
        return true;
      }
      return false;
    },
    showFeesTax() {
      if (
        this.moveInCost.fee_tax_total &&
        parseFloat(this.moveInCost.fee_tax_total) > 0
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
